import { notification } from "antd";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { useSendApproval } from "../mutate-hooks/use-send-approval";

interface IUseSendApprovalModal {
  setIsLoading?: (isLoading: boolean) => void;
  handleClear: () => void;
}

export const useSendApproveModal = ({
  setIsLoading,
  handleClear,
}: IUseSendApprovalModal) => {
  const { titleId } = useCoordinator();
  const { mutate: sendApproval } = useSendApproval({ titleId });

  const handleSendApproval = async () => {
    setIsLoading?.(true);
    sendApproval({
      onSuccess: () => {
        notification.success({
          message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
          description: NOTIFICATION_MESSAGES.TITLE_SENT_TO_REVIEW_DESC, // "Титульный лист отправлен на проверку"
          placement: "topRight",
        });
        handleClear();
      },
      onError: () => {
        notification.error({
          message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
          description: NOTIFICATION_MESSAGES.TITLE_SEND_TO_REVIEW_FAILED_DESC, // "Не удалось отправить на проверку"
          placement: "topRight",
        });
        handleClear();
      },
      onSettled: () => {
        setIsLoading?.(false);
      },
    });
  };

  return { handleSendApproval };
};
